import { Suspense } from 'react';
import { Outlet, useNavigation } from 'react-router';
import { AppSharedContextProvider } from './AppSharedContextProvider.component';
import CssThemeProvider from './CssThemeProvider.component';
import { LoadingOverlay } from '../common/loadingOverlay/LoadingOverlay.component';
import { AuthorizedPageWrapper } from './layout/AuthorizedPageWrapper.component';
import RetryableErrorBoundary from '../common/errorBoundary/RetryableErrorBoundary.component';

export const Wrapper = () => {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);
  return (
    <AppSharedContextProvider>
      <AuthorizedPageWrapper>
        <Suspense fallback={<LoadingOverlay />}>
          {isNavigating && (
            <LoadingOverlay
              sxProp={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: 'rgba(255,255,255, 0.5)',
              }}
            />
          )}
          <Outlet />
        </Suspense>
      </AuthorizedPageWrapper>
    </AppSharedContextProvider>
  );
};

export const RootLayout = () => (
  <CssThemeProvider>
    <RetryableErrorBoundary>
      <Suspense fallback={<LoadingOverlay />}>
        <Outlet />
      </Suspense>
    </RetryableErrorBoundary>
  </CssThemeProvider>
);
